/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUser,
    AcademicUserFromJSON,
    AcademicUserFromJSONTyped,
    AcademicUserToJSON,
} from './AcademicUser';
import {
    StudyPlan,
    StudyPlanFromJSON,
    StudyPlanFromJSONTyped,
    StudyPlanToJSON,
} from './StudyPlan';
import {
    StudyPlanStatusEnum,
    StudyPlanStatusEnumFromJSON,
    StudyPlanStatusEnumFromJSONTyped,
    StudyPlanStatusEnumToJSON,
} from './StudyPlanStatusEnum';

/**
 * 
 * @export
 * @interface StudyPlanStatusHistory
 */
export interface StudyPlanStatusHistory {
    /**
     * 
     * @type {string}
     * @memberof StudyPlanStatusHistory
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof StudyPlanStatusHistory
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyPlanStatusHistory
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanStatusHistory
     */
    studyPlanId?: string;
    /**
     * 
     * @type {StudyPlan}
     * @memberof StudyPlanStatusHistory
     */
    studyPlan?: StudyPlan;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanStatusHistory
     */
    userId?: string;
    /**
     * 
     * @type {AcademicUser}
     * @memberof StudyPlanStatusHistory
     */
    user?: AcademicUser;
    /**
     * 
     * @type {string}
     * @memberof StudyPlanStatusHistory
     */
    message?: string | null;
    /**
     * 
     * @type {StudyPlanStatusEnum}
     * @memberof StudyPlanStatusHistory
     */
    status?: StudyPlanStatusEnum;
}

export function StudyPlanStatusHistoryFromJSON(json: any): StudyPlanStatusHistory {
    return StudyPlanStatusHistoryFromJSONTyped(json, false);
}

export function StudyPlanStatusHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyPlanStatusHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
        'studyPlan': !exists(json, 'studyPlan') ? undefined : StudyPlanFromJSON(json['studyPlan']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'user': !exists(json, 'user') ? undefined : AcademicUserFromJSON(json['user']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'status': !exists(json, 'status') ? undefined : StudyPlanStatusEnumFromJSON(json['status']),
    };
}

export function StudyPlanStatusHistoryToJSON(value?: StudyPlanStatusHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'studyPlanId': value.studyPlanId,
        'studyPlan': StudyPlanToJSON(value.studyPlan),
        'userId': value.userId,
        'user': AcademicUserToJSON(value.user),
        'message': value.message,
        'status': StudyPlanStatusEnumToJSON(value.status),
    };
}

